import React from 'react';
import styled from 'styled-components/macro';
import { telescope } from '../../ui-icons/illustrations';
import { mainTheme } from '../../styles/themes/main-theme';

const EmptyResultsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${mainTheme.containerMargins.big};
    text-align: center;
`;

const EmptyResultsTitle = styled.div`
    font-size: ${mainTheme.fontSizes.big};
    font-weight: 500;
    color: ${mainTheme.colors.grey};
    margin-bottom: ${mainTheme.containerMargins.extrasmall};
`;

const EmptyResultsSubtitle = styled.div`
    font-size: ${mainTheme.fontSizes.normal};
    color: ${mainTheme.colors.lightGrey};
    margin-bottom: ${mainTheme.containerMargins.small};
`;

const TelescopeIcon = styled.div`
    margin-top: ${mainTheme.containerMargins.small};
`;

export const EmptySearchResults: React.FC = () => {
    return (
        <EmptyResultsWrapper>
            <EmptyResultsTitle>There are no items matching your search</EmptyResultsTitle>
            <EmptyResultsSubtitle>Adjust your search input and try again</EmptyResultsSubtitle>
            <TelescopeIcon>{telescope}</TelescopeIcon>
        </EmptyResultsWrapper>
    );
};
